import React from 'react';
import { Navigate, Outlet } from 'react-router';

import { useSignedIn } from '@/core/auth/auth';

export const RequireAuth: React.FC = () => {
  const signedIn = useSignedIn();
  if (!signedIn) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
};
